<template>
    <!-- Aviso general del estado del servicio (src/services/avisoServicio.js): arriba del contenido, también en la
         entrada, para que se lea antes de empezar -->
    <div v-if="visible" class="aviso-servicio" role="status" aria-live="polite">
        <div class="aviso-contenido">
            <i class="fas fa-exclamation-triangle aviso-icono" aria-hidden="true"></i>
            <div class="aviso-texto">
                <p v-if="aviso.titulo" class="fw-bold mb-1">{{ aviso.titulo }}</p>
                <p class="mb-0">{{ aviso.mensaje }}</p>
            </div>
            <button type="button" class="btn-close" aria-label="Cerrar el aviso" @click="cerrar()"></button>
        </div>
    </div>
</template>

<script>
import { avisoServicio } from "@/services/avisoServicio";

// Quien cierra el aviso no lo vuelve a ver en esta pestaña, salvo que el mensaje cambie
const CLAVE_CERRADO = "avisoServicioCerrado";

function leerCerrado() {
    try {
        return sessionStorage.getItem(CLAVE_CERRADO) || "";
    } catch (error) {
        return "";
    }
}

export default {
    name: "AvisoServicio",

    data() {
        return {
            aviso: avisoServicio,
            cerrado: leerCerrado(),
        };
    },

    computed: {
        visible() {
            return this.aviso.activo && this.cerrado !== this.aviso.mensaje;
        },
    },

    methods: {
        cerrar() {
            this.cerrado = this.aviso.mensaje;
            try {
                sessionStorage.setItem(CLAVE_CERRADO, this.aviso.mensaje);
            } catch (error) { /* sin almacenamiento: vale mientras la pestaña siga abierta */ }
        },
    },
};
</script>

<style scoped>
/* Los mismos colores del aviso de correo sin verificar de Editar perfil */
.aviso-servicio {
    /* Por encima del fondo fijo de la entrada (z-index 0 y 1) y por debajo de su modo cine (3) */
    position: relative;
    z-index: 2;
    max-width: 1400px;
    margin: 0 auto;
    padding: 12px 15px 0;
}

.aviso-contenido {
    display: flex;
    align-items: flex-start;
    gap: 12px 16px;
    padding: 14px 18px;
    border: 1px solid #d9a521;
    border-radius: 10px;
    background-color: #fff4d6;
    color: #4a3400;
    text-align: left;
}

.aviso-icono {
    margin-top: 3px;
    font-size: 1.3rem;
    color: #8a5a00;
}

.aviso-texto {
    flex: 1 1 auto;
    min-width: 0;
    line-height: 1.45;
    overflow-wrap: anywhere;
}

.btn-close {
    flex: none;
    margin-top: 2px;
}

@media screen and (max-width: 767px) {
    .aviso-servicio {
        padding: 10px 10px 0;
    }

    .aviso-contenido {
        padding: 12px 14px;
    }
}
</style>
